/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthOtpResponse as ModelsAuthenticationAuthOtpResponse } from '../../models/Models/Authentication/auth-otp-response';

export interface V4CustomersMeDetailsOtpGet$Xml$Params {
  mobile?: string;
  email?: string;
}

export function v4CustomersMeDetailsOtpGet$Xml(http: HttpClient, rootUrl: string, params?: V4CustomersMeDetailsOtpGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthOtpResponse>> {
  const rb = new RequestBuilder(rootUrl, v4CustomersMeDetailsOtpGet$Xml.PATH, 'get');
  if (params) {
    rb.query('mobile', params.mobile, {});
    rb.query('email', params.email, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsAuthenticationAuthOtpResponse>;
    })
  );
}

v4CustomersMeDetailsOtpGet$Xml.PATH = '/v4/customers/me/details-otp';
